import { ChangeDetectorRef, Directive, Input, inject } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Status } from '@df/core/status';
import { NSagepay } from '../sagepay.namespace';
import { SagepayCloudPaymentService } from './sagepay-cloud-payment.service';

@Directive()
export abstract class SagepayCloudPaymentRenewPaymentComponentDef {
    @Input()
    successData: Checkout.ISuccessData;
    
    newSpcpNumber?: number;
    status = new Status();

    protected sagepayCloudPayment = inject(SagepayCloudPaymentService);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    renew() {
        if (this.successData?.number) {
            this.sagepayCloudPayment.renewPayment(
                this.status,
                { order_increment_id: this.successData.number },
                (response: NSagepay.ICloudPaymentRenewPaymentResponse) => {
                    this.setNumber(response?.sccp_reference);
                },
                () => {
                    this.setNumber(undefined);
                }
            );
        }
    }

    protected setNumber(value: number | undefined): void {
        this.newSpcpNumber = value;
        this.changeDetectorRef.detectChanges();
    }
}